export default __webpack_public_path__ + "static/media/icon-token.cd0c09bd.svg";